import React, { Component } from "react";
import { Grid, Row, Col, Table, FormGroup } from "react-bootstrap";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import Card from "components/Card/Card.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import Datetime from "react-datetime";
import moment from "moment";
import { ExportToCsv } from 'export-to-csv';
import Button from "components/CustomButton/CustomButton.jsx";

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

class Forms extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      formsList : null,
      dateStart: moment().subtract(1, 'months'),
      dateEnd: moment(),
      runningSearch : false,
      runningDeleteForm : false,
      runningDeleteAllForms : false,
      formFields : []
    }
  }

  componentDidMount () {
    this.fetchForms();
  }

  setDateStart(d){
    this.setState({dateStart : d});
  }

  setDateEnd(d){
    this.setState({dateEnd : d});
  }  

  fetchForms(){
    this.setState({runningSearch : true});

    fetch("https://"+WEB_URL+"/account/api/forms",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&detail=true',
      body: JSON.stringify({token : this.props.authDetail.token, checksum : this.props.authDetail.checksum, detail : true, publication : this.props.match.params.publication, searchDateFrom : this.state.dateStart.toISOString(), searchDateTo : this.state.dateEnd.toISOString()})
    }).then(res => res.json())
      .then(
        (response) => {
          if(response.Error == "Authentication Failed"){
            this.props.setLoggedIn(false);    
            return;
          }

          var dl = [];
          for(var p=0;p<response.forms.length;p++){
              dl.push(response.forms[p]);
          }
          this.setState({formsList : dl})
          this.setState({runningSearch : false});
        },
        (error) => {
          debugger;
          this.setState({runningSearch : false});
        }
      )
  }

  csvExport(){
    const options = { 
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true, 
      showTitle: true,
      title: 'Forms for ' + this.props.match.params.publication,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(this.state.formsList);
  }

  deleteAllForms(){
    if(window.confirm('Are you sure you want to delete all forms for this publication?')){
        this.setState({runningDeleteAllForms : true});

        fetch("https://"+WEB_URL+"/account/api/forms",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&identifier='+publication[0]
        'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'action':'deleteAllForms','publication':this.props.match.params.publication})
      }).then(res => res.json())
        .then(
          (response) => {
            this.setState({runningDeleteAllForms : false});
            if(response.result == 'SUCCESS'){
              this.props.triggerNotification('success','tc',response.message);
              this.fetchForms();
            }else{
              this.props.triggerNotification('error','tc',response.message);  
              this.setState({runningDeleteCloudPublication : false});
            }
          },
          (error) => {
            this.props.triggerNotification('error','tc','Error deleting the forms. Please try again in a little while.');
            this.setState({runningDeleteAllForms : false});
          }
        )
    }  
  }

  deleteForm(form){
    if(window.confirm('Are you sure you want to delete this entry?')){
      this.setState({runningDeleteForm : form});

      fetch("https://"+WEB_URL+"/account/api/forms",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&identifier='+publication[0]
        'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'action':'deleteForm','identifier':form.id,'publication':this.props.match.params.publication})
      }).then(res => res.json())
        .then(
          (response) => {
            if(response.result == 'SUCCESS'){
              this.props.triggerNotification('success','tc',response.message);
              this.fetchForms();
              this.setState({runningDeleteForm : false});
            }else{
              this.props.triggerNotification('error','tc',response.message);  
              this.fetchForms();
              this.setState({runningDeleteForm : false});
            }
          },
          (error) => {
            this.props.triggerNotification('error','tc','Error deleting the entry. Please try again in a little while.');
            this.fetchForms();
            this.setState({runningDeleteForm : false});
          }
        )
    }
  }

  getCloudLink(publication){
    if(this.props.authDetail.detail.cloudId && this.props.authDetail.detail.cloudId != this.props.authDetail.user){
      return "https://"+this.props.authDetail.detail.cloudId+".flowpaper.com/"+publication+"/";
    }else{
      return "https://online.flowpaper.com/"+this.props.authDetail.user+"/"+publication+"/";
    }
  }

  goBack(){
    this.props.history.push('/home/cloud/'); 
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <ProgressButton bsStyle="default btn-wd btn btn-sm" fill type="submit" onClick={(e) => {this.goBack(e);}}><i class="pe-7s-back"></i> Go Back</ProgressButton>
              <h4 style={{'margin-top':20}}><b>Publication</b>: <a target="_new" href={this.getCloudLink(this.props.match.params.publication)}>{this.getCloudLink(this.props.match.params.publication)}</a></h4>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <FormGroup>
                <label class="control-label">Date From</label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Datetime Picker Here" }}
                  defaultValue={this.state.dateStart}
                  onChange={(d) => this.setDateStart(d)}
                />
               </FormGroup>
             </Col>
             <Col md={2}>
              <FormGroup>
                <label class="control-label">Date To</label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Datetime Picker Here" }}
                  defaultValue={this.state.dateEnd}
                  onChange={(d) => this.setDateEnd(d)}
                />
               </FormGroup>
             </Col>      
             <Col md={6}>
              <FormGroup>
                <label style={{visibility:'hidden',display:'block'}} class="control-label">---</label>
                <ProgressButton runningAsyncOperation={this.state.runningSearch} bsStyle="info" fill type="submit" onClick={(e) => {this.fetchForms(e);}}>
                    Search
                </ProgressButton>
                <ProgressButton runningAsyncOperation={this.state.exportingCSV} bsStyle="info" fill type="submit" onClick={(e) => {this.csvExport(e);}} style={{'margin-left':'10px'}}>
                    Export to CSV
                </ProgressButton>
                <ProgressButton runningAsyncOperation={this.state.runningDeleteAllForms} bsStyle="danger pull-right" fill type="submit" onClick={(e) => {this.deleteAllForms(e);}}>
                      Delete All
                  </ProgressButton>
              </FormGroup>
             </Col>       
          </Row>
          {this.state.formsList!=null ? 
          <Row>
            <Col md={12}>
            {this.state.formsList.length ? 
            <Card
                title=""
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                      {(() => {
                        this.state.formFields = [];
                        var th = [];

                        for (let prop in this.state.formsList[0]) {
                          if(prop != 'id' && prop != 'visitorLocation' && prop != 'URL' && prop != 'created_at' && this.state.formsList.length < 10){
                            this.state.formFields.push(prop);
                            th.push(<th>{prop}</th>);
                          }
                        }
                        return th;
                      })()}
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.formsList.map((form, index) => {
                      
                        return (
                            <tr key={`${form.id}`}>
                            {(() => {
                              var td = [];
                              for (var fi=0;fi<this.state.formFields.length;fi++) {
                                var prop = this.state.formFields[fi];

                                if (form.hasOwnProperty(prop)) {
                                  if(prop != 'id' && prop != 'visitorLocation' && prop != 'URL' && prop != 'created_at'){
                                    td.push(<th>{form[prop]}</th>);
                                  }
                                }
                              }
                              return td;
                            })()}     

                            <td>
                              <ProgressButton style={{'min-height':'28px','min-width':'77px'}} runningAsyncOperation={this.state.runningDeleteForm == form} bsStyle="danger pull-right btn-xs" fill type="submit" onClick={(e) => {this.deleteForm(form,e);}}>
                                Delete Entry
                                </ProgressButton>
                            </td>
                            </tr>
                        );
                    })}
                    </tbody>
                  </Table>
                }
              />:<Card
              title=""
              category=""
              ctTableFullWidth
              ctTableResponsive
              content={
                <div style={{margin:20}}>No available forms for this publication in the selected period</div>
              }/>}
            </Col>
          </Row>
          :<div className="spinner-grow text-primary" role="status">
          <span className="sr-only">Loading...</span>
          </div>}
        </Grid>
      </div>
    );
  }
}

export default Forms;
